import { History } from 'history';
import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Route, Router, Switch } from 'react-router-dom';
import { TeamMembersDTO } from '../../services/server-types';
import Modals from '../Modals/Modals';
import { connect, ConnectedProps } from 'react-redux';
import Toasts from '../Toasts/Toasts';
import FirstTimeExperience from '../FirstTimeExperience';
import routes, { setRouteTitle } from './routes';
import { connector } from './index';
import { createHistory } from '../../services/historyService';
import { InjectedExperimentsProps, withExperiments } from '@wix/wix-experiments-react';

interface IAppProps extends InjectedTranslateProps, InjectedExperimentsProps, ConnectedProps<typeof connector> {
  shouldShowFirstTimeExperience: boolean;
  isSiteLevel: boolean;
  basename?: string;
  history?: History;

  fetchTeamMembers(shouldUseServerPredefinedConfigFile?: boolean): Promise<TeamMembersDTO>;
  fetchAreas(): void;
  fetchTeamMemberUsers(teamMembersDTO: TeamMembersDTO): Promise<TeamMembersDTO>;
  setEnforceContributors(shouldEnforceContributors: boolean): void;
  notifyViewFinishedLoading(): void;
}

class App extends React.Component<IAppProps> {
  fetchTeamMembersPromise;
  history: History;
  state = { finishedLoading: false };

  constructor(props) {
    super(props);

    this.fetchTeamMembersPromise = props.fetchTeamMembers(this.props.experiments.enabled('specs.ident.ShouldUseServerPredefinedConfigFile'));

    const basename = props.basename || '';
    this.history = createHistory({ basename }, this.props.history);
  }

  componentDidMount() {
    this.fetchTeamMembersPromise.then((teamMembersDTO) => {
      this.props.notifyViewFinishedLoading();
      // used in order to display animations that the loader is hiding
      this.setState(() => ({
        finishedLoading: true,
      }));
      this.props.fetchAreas();
      this.props.fetchTeamMemberUsers(teamMembersDTO);
      this.props.setEnforceContributors(this.props.experiments.enabled('specs.ident.EnforceContributors'));
    });
  }

  render() {
    const { t, shouldShowFirstTimeExperience, isSiteLevel } = this.props;
    const pageTitle = t(isSiteLevel ? 'breadcrumbs.people' : 'breadcrumbs.teammates');
    setRouteTitle('teammates', pageTitle);

    if (this.state.finishedLoading && shouldShowFirstTimeExperience) {
      return (<FirstTimeExperience />);
    }

    return (
      <Router history={this.history}>
        <div data-hook="account-team-app-root">
          <Toasts />
          <Switch>
            {routes.map(({ id, exact, path, component }) =>
              <Route
                key={id}
                path={path}
                component={component}
                exact={exact}
              />
            )}
          </Switch>
          <Modals />
        </div>
      </Router>
    );
  }
}

export default withExperiments(connect()(translate()(App)));
